<app-cw-new-card [showHeader]="true" [showBody]="true">
  <div header>
    <app-cw-card-header
      [title]="templateTitle | translation: templateContent.TEMPLATE_CONTENT: lang"
      [subtitle]="templateSubTitle | translation: templateContent.TEMPLATE_CONTENT: lang"
    />
  </div>

  <div body class="my-4 event-body">
    @if (cart.length <= 0) {
      <div class="no-data">{{ 'appointments.step4.cart.emptyCartWarning' | translate }}</div>
    }

    @if (cart) {
      <div>
        @for (cartItem of cart; track cartItem; let i = $index; let last = $last) {
        <div class="row cw-cart-row">
          <div class="col-md-12">
            <div class="d-flex align-items-center padding-inline-15px">
              <div class="service">
                <ngx-clamp row="3">
                  <div class="name" #content>
                    <span class="cart text-break">
                      {{ cartItem.referenceEvent | translation: 'title' : lang }}
                    </span>
                  </div>
                </ngx-clamp>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="appointment mt-1 padding-inline-15px" [ngClass]="{ 'appointment-padding': cart.length != 1 }">
              @if (cartItem?.childSlots?.length) {
                @for (slot of cartItem?.childSlots; track slot.id) {
                  <div class="cbw-summary-date-time">
                    {{ slot.start | date: datePipeWithComma }} - {{ slot.end | date: timeFormat }}
                  </div>
                }
              } @else {
                @if (((cartItem.startTime | date: dateFormat) === (cartItem.endTime | date: dateFormat))) {
                  <span class="cbw-summary-date-time">
                    {{ cartItem.startTime | date: datePipeWithComma }} - {{ cartItem.endTime | date: timeFormat }}
                  </span>
                } @else {
                  <span class="cbw-summary-date-time">
                    {{ cartItem.startTime | date: dateTimeFormat }} - {{ cartItem.endTime | date: dateTimeFormat }}
                  </span>
                }
              }
              @if (showWidgetSlotLocation) {
                <div class="cbw-summary-date-time d-flex mt-1">
                  @if (cartItem?.location) {
                    @if (
                      [1, 12].includes(cartItem?.meeting_type_id) &&
                      cartItem?.location?.trim() !== ',' &&
                      (cartItem?.location | isEmptyString)
                    ) {
                      {{ 'common.location' | translate }}: {{ cartItem?.location }}
                    } @else if (cartItem?.meeting_type_id && ![1, 12]?.includes(cartItem?.meeting_type_id)) {
                      <ng-container *ngTemplateOutlet="meetingType; context: { eventInfo: cartItem }"/>
                    }
                  } @else {
                    @if (
                      [1, 12].includes(eventState?.meeting_type_id) &&
                      eventState?.place?.trim() !== ',' &&
                      (eventState?.place | isEmptyString)
                    ) {
                      {{ 'common.location' | translate }}: {{ eventState?.place }}
                    } @else if (![1, 12]?.includes(eventState?.meeting_type_id) && eventState?.meeting_type_id) {
                      <ng-container *ngTemplateOutlet="meetingType; context: { eventInfo: eventState }"/>
                    }
                  }
                </div>
              }
            </div>
            <div class="padding-inline-15px mt-1 d-none d-md-block">
              <a class="remove-link" href="javascript:void(0)" (click)="removeFromCart( cartItem.slotId )">
                {{ 'buttons.remove' | translate }}
              </a>
            </div>
          </div>

          <div class="col-md-4">
            @if (eventState?.is_multi_day !== 1) {
              @if (partner.hide_mail_resource !== 1) {
                <div class="worker-name padding-inline-15px">
                  @if ((cartItem.duration | replaceComma | eventToHour) > 0) {
                  <span>
                    {{ cartItem.duration | replaceComma | eventToHour }}{{ 'common.durationHour' | translate }}
                  </span>
                  }
                  @if ((cartItem.duration | replaceComma | eventToMinute) > 0) {
                    <span>
                      {{ cartItem.duration | replaceComma | eventToMinute }}{{ 'common.durationMinute' | translate }}
                    </span>
                  }
                </div>
              }
            }
          </div>

          <div class="col-md-2">
            <div class="no-wrap price text-md-end padding-inline-15px">
              @if (cartItem.currentEvent?.price > 0) {
                <span>
                  {{ cartItem.currentEvent?.price | calioCurrency: partner.currency: lang }}
                </span>
              } @else {
                <span>
                  {{ cartItem.currentEvent?.price | price | translate | titlecase }}
                </span>
              }

              @if (cartItem?.currentEvent?.taxRate >= 0) {
                <div class="vat cbw-taxes">
                  @if (isVatAddedOnTop(partner?.widget_vat_type) && getItemVatAmount(cartItem.currentEvent.taxRate, cartItem.currentEvent.price) > 0) {
                    + {{ getItemVatAmount(cartItem.currentEvent.taxRate, cartItem.currentEvent.price) | calioCurrency: partner?.currency: lang }}
                  }
                  ({{ 'tax_info.' + vatTypeLabelKey(partner?.widget_vat_type) | translate }}
                  @if (vatTypeLabelKey(partner?.widget_vat_type) !== 'exclude') {
                    <span class="cbw-taxes-percentage">{{ cartItem?.currentEvent?.taxRate }}%</span>
                  }
                  {{ 'tax_info.taxes' | translate }})
                </div>
              }
            </div>
          </div>

          <div class="col-md-12 d-block d-md-none">
            <div class="padding-inline-15px mt-1">
              <a class="remove-link" href="javascript:void(0)" (click)="removeFromCart(cartItem.slotId)">
                {{ 'buttons.remove' | translate }}
              </a>
            </div>
          </div>

          @if ((finalCouponDiscount > 0 || finalTotal !== 0 && cart && cart.length > 0) ||
            (cart && cart.length > 1 && !last)) {
              <hr class="card-divider w-100">
          }
        </div>
        }

        @if (customFields?.length) {
          <div class="row cw-cart-row cbw-addons-custom-fields-wrapper">
            <div class="cbw-addons-custom-fields cbw-addons-personal-info-view">
              <app-customfields
                [(userState)]="userState"
                [globals]="globals"
                [customFields]="customFields"
                [partner]="partner"
                [selectedJsonCustomFields]="selectedJsonCustomFields"
                [lang]="lang"
                [widgetTemplates]="widgetTemplates"
                [customFieldValues]="customFieldValues"
                [customFieldValuesLSNameKey]="customFieldValuesLSNameKey"
              />
            </div>
          </div>
        }

        @if (finalCouponDiscount > 0 || finalTotal !== 0 && cart && cart.length > 0) {
        <div class="row cw-cart-row">
          <div class="col-lg-6 col-md-6"></div>
          <div class="col-lg-6 col-md-6">
            <!-- Combined row: named + anonymous shown as one "additional guests" line.
                 Distinction is still visible in the participant cards above; the cart
                 summary just shows total count + amount for a cleaner subtotal block. -->
            @if (combinedGuestCount > 0) {
            <div class="d-flex justify-content-start justify-content-md-end">
              <div class="row total-row cw-cart-row padding-inline-15px">
                <div class="col-lg-7 col-md-7 normal-field-label padding-inline-15px">
                  @if (combinedGuestCount === 1) {
                  <div>{{ 'common.additionalGuestCartLabel' | translate : { number: combinedGuestCount } }}</div>
                  } @else {
                  <div>{{ 'common.additionalGuestsCartLabel' | translate : { number: combinedGuestCount } }}</div>
                  }
                </div>
                <div class="col-lg-5 col-md-5 text-md-end normal-field-label padding-inline-15px">
                  <span>
                    @if (_totalCartPrice > 0) {
                      {{ (combinedGuestCount * _totalCartPrice) | calioCurrency: partner.currency: lang }}
                    }
                    @if (_totalCartPrice === 0) {
                      {{ 'free' | translate }}
                    }
                    @if (_totalCartPrice === -1) {
                      &nbsp;
                    }
                  </span>
                </div>
              </div>
            </div>
            }

            @if (_customFieldsAddonsPrice > 0) {
              <div class="d-flex justify-content-start justify-content-md-end cbw-addons-custom-fields-subtotal-wrapper">
                <div class="row total-row cw-cart-row cbw-addons-custom-fields-subtotal-row padding-inline-15px">
                  <div class="col-lg-7 col-md-7 bold-field-label cbw-addons-custom-fields-subtotal-label padding-inline-15px">
                    {{ templateAddonUpgradeLabel | translation: templateContent.TEMPLATE_CONTENT: lang }}
                  </div>
                  <div class="col-lg-5 col-md-5 text-md-end bold-field-label cbw-addons-custom-fields-subtotal-price padding-inline-15px">
                    <span>
                      {{ _customFieldsAddonsPrice | calioCurrency: partner?.currency: lang }}
                    </span>
                  </div>
                </div>
              </div>
            }

            @if (vatTypeLabelKey(partner?.widget_vat_type) !== 'exclude' || coupon) {
              <div class="d-flex justify-content-start justify-content-md-end cbw-subtotal-wrapper">
                <div class="row total-row cw-cart-row cbw-subtotal-row padding-inline-15px">
                  <div class="col-lg-7 col-md-7 bold-field-label cbw-subtotal-label padding-inline-15px">
                    <div>{{ subtotalLabelKey() | translate }}</div>
                  </div>
                  <div class="col-lg-5 col-md-5 text-md-end bold-field-label cbw-subtotal-price padding-inline-15px">
                    <span>
                      @if (_totalCartPrice > 0) {
                        {{ ((1 + (additionalGuests?.length ?? 0) + (anonymousGuestCount ?? 0)) * _totalCartPrice) | calioCurrency: partner.currency: lang }}
                      }
                      @if (_totalCartPrice === 0) {
                        {{ 'free' | translate }}
                      }
                      @if (_totalCartPrice === -1) {
                        &nbsp;
                      }
                    </span>
                  </div>
                </div>
              </div>
            }

            @if (coupon) {
            <div class="d-flex justify-content-start justify-content-md-end mt-2">
              <div class="row total-row cw-cart-row padding-inline-15px">
                <div class="col-lg-7 col-md-7 normal-field-label padding-inline-15px">
                  {{ 'coupon_credit_card_info.coupon' | translate }} ({{ coupon.code }})
                </div>
                <div class="col-lg-5 col-md-5 text-md-end normal-field-label padding-inline-15px">
                  <span>
                    - {{ finalCouponDiscount | calioCurrency: partner.currency: lang }}
                  </span>
                </div>
              </div>
            </div>
            }
            @if (isVatAddedOnTop(partner?.widget_vat_type)) {
              @for (rate of vat().byRate; track rate.rate) {
                <div class="d-flex justify-content-start justify-content-md-end">
                  <div class="row total-row cw-cart-row padding-inline-15px">
                    <div class="col-lg-7 col-md-7 normal-field-label padding-inline-15px">
                      {{ 'tax_info.tax_line' | translate: { percentage: rate.rate } }}
                    </div>
                    <div class="col-lg-5 col-md-5 text-md-end normal-field-label padding-inline-15px">
                      <span>
                        + {{ (rate.amountCents / 100) | calioCurrency: partner.currency: lang }}
                      </span>
                    </div>
                  </div>
                </div>
              }
            } @else {
              @for (rate of containedVat().byRate; track rate.rate) {
                <div class="d-flex justify-content-start justify-content-md-end">
                  <div class="row total-row cw-cart-row padding-inline-15px">
                    <div class="col-lg-7 col-md-7 normal-field-label padding-inline-15px">
                      {{ 'tax_info.tax_included_line' | translate: { percentage: rate.rate } }}
                    </div>
                    <div class="col-lg-5 col-md-5 text-md-end normal-field-label padding-inline-15px">
                      <span>
                        {{ (rate.amountCents / 100) | calioCurrency: partner.currency: lang }}
                      </span>
                    </div>
                  </div>
                </div>
              }
            }
            <div class="d-flex justify-content-start justify-content-md-end">
              <div class="row total-row cw-cart-row padding-inline-15px">
                <hr class="card-divider w-100">
                <div class="col-lg-7 col-md-7 bold-field-label padding-inline-15px">
                  {{ totalLabelKey() | translate }}
                </div>
                <div class="col-lg-5 col-md-5 text-md-end red-bold-field-label padding-inline-15px">
                  <span>
                    {{ finalTotal | calioCurrency: partner.currency: lang }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    }
  </div>
</app-cw-new-card>


<ng-template #meetingType let-eventInfo="eventInfo">
  @if (eventInfo?.meeting_type_id === 1) {
    <img src="{{ environment.baseUrl }}/images/meetings/store.svg" alt="Store Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 2) {
    <img src="{{ environment.baseUrl }}/images/meetings/zoom.svg" alt="Zoom Logo" width="15px" />
  }  @else if (eventInfo?.meeting_type_id === 4) {
    <img src="{{ environment.baseUrl }}/images/meetings/phone.svg" alt="Phone Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 5) {
    <img src="{{ environment.baseUrl }}/images/meetings/customer.svg" alt="Customer Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 6) {
    <img src="{{ environment.baseUrl }}/images/meetings/unblu.svg" alt="Unblu Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 7) {
    <img src="{{ environment.baseUrl }}/images/meetings/teams.svg" alt="Teams Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 8) {
    <img src="{{ environment.baseUrl }}/images/meetings/meet.svg" alt="Meet Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 9) {
    <img src="{{ environment.baseUrl }}/images/meetings/gotomeeting.png" alt="Gotomeeting Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 10) {
    <img src="{{ environment.baseUrl }}/images/meetings/webex.png" alt="Webex Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 11) {
    <img src="{{ environment.baseUrl }}/images/meetings/phone.svg" alt="Phone Logo" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 13) {
    <img src="{{ environment.baseUrl }}/images/meetings/metaverse.svg" alt="Metaverse" width="15px" />
  } @else if (eventInfo?.meeting_type_id === 15) {
    <img src="{{ environment.baseUrl }}/images/meetings/kmeet.png" alt="kMeet" width="15px" />
  }
  @if ((widgetTemplates | calioMeetingTemplate: { id: eventInfo?.meeting_type_id, type: 'meeting_template' }); as widgetTemplate) {
    <div class="meeting-option">
      @if ((widgetTemplate.titleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang)) {
        <div class="meeting-type-name"
          [innerHTML]="(widgetTemplate.titleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml">
        </div>
      }
    </div>
  }
</ng-template>
